<template>
  <div class="tour-linechart">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
// v2.9.4 import
import Chart from 'chart.js';

export default {
  name: 'TourLinechart',
  props: {
    chartData: {
      type: Object,
      required: true,
      default: () => ({ labels: [], datasets: [] })
    }
  },
  data() {
    return {
      chartInstance: null
    };
  },
  mounted() {
    this.renderChart();
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    this.destroyChart();
    window.removeEventListener('resize', this.onResize);
  },
  watch: {
    chartData: {
      deep: true,
      handler() {
        this.renderChart();
      }
    }
  },
  methods: {
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
      const ctx = this.$refs.canvas.getContext('2d');
      this.chartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.chartData.labels,
          datasets: this.chartData.datasets.map((ds, i) => ({
            ...ds,
            borderColor: ds.borderColor || (i === 0 ? '#00ffe5' : '#1affff'),
            backgroundColor: ds.backgroundColor || 'rgba(0,255,229,0.2)',
            fill: ds.fill || false,
            // v2 uses lineTension, not tension
            lineTension: 0.3,
            pointRadius: 4,
            pointBackgroundColor: ds.pointBackgroundColor || '#ffffff'
          }))
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          // v2 legend config
          legend: {
            labels: { fontColor: '#ffffff' }
          },
          // v2 tooltips config (not under plugins)
          tooltips: {
            enabled: true,
            titleFontColor: '#ffffff',
            bodyFontColor: '#ffffff',
            backgroundColor: 'rgba(0,0,0,0.7)'
          },
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Year',
                fontColor: '#ffffff'
              },
              ticks: {
                fontColor: '#ffffff'
              },
              gridLines: {
                color: 'rgba(255,255,255,0.1)'
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                fontColor: '#ffffff'
              },
              scaleLabel: {
                display: true,
                labelString: 'Shows',
                fontColor: '#ffffff'
              },
              gridLines: {
                color: 'rgba(255,255,255,0.1)'
              }
            }]
          }
        }
      });
    },
    destroyChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
    },
    onResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  }
};
</script>

<style scoped>
.tour-linechart {
  width: 100%;
  min-height: 230px;
  position: relative;
}
</style>
